// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3Xm_a","footer":"ReportModalFilter_footer__3DU89"};